// extracted by mini-css-extract-plugin
module.exports = {"chartLineExample":"index_chartLineExample_12oN5","chartBarExample":"index_chartBarExample_4V9ze","chartPieExample":"index_chartPieExample_9PRS6"};